import React from 'react';
import { motion } from 'framer-motion';
import { Menu } from 'lucide-react';
export function LayerMenu() {
  return <section className="py-24 bg-slate-950" data-id="element-52">
      <div className="max-w-7xl mx-auto px-6" data-id="element-53">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-16" data-id="element-54">
          <div className="flex items-center gap-3 mb-4" data-id="element-55">
            <div className="bg-red-600 text-white px-4 py-1 rounded-full text-sm font-semibold" data-id="element-56">
              LAYER 2
            </div>
            <Menu className="w-5 h-5 text-red-600" data-id="element-57" />
          </div>
          <h2 className="font-editorial text-4xl md:text-5xl font-bold text-white mb-4" data-id="element-58">
            The Menu
          </h2>
          <p className="text-xl text-slate-300 max-w-3xl" data-id="element-59">
            Choose your path — browse by speaker expertise or by clinical topic.
            A premium streaming experience that puts the viewer in control.
          </p>
        </motion.div>

        {/* Actual presentation slide */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} className="relative rounded-2xl overflow-hidden shadow-2xl ring-1 ring-white/10 bg-[#2d4a35]" data-id="element-60">
          <img src="https://cdn.magicpatterns.com/uploads/uZkELaGS27dDVhuH4oWYna/Screenshot_2026-05-07_at_1.13.18_PM.png" alt="Choose your topic — speaker and topic menu" className="w-full h-auto block" data-id="element-61" />
        </motion.div>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.6
      }} className="text-center text-slate-400 mt-12 italic" data-id="element-62">
          Seven entry points. Each KEE paired with their signature topic.
        </motion.p>
      </div>
    </section>;
}